import React, { useState } from 'react'

import { SearchOutlined, Stop, ThumbDown, ThumbUp } from '@mui/icons-material'

import ManualAnalysisForm from 'components/ManualAnalysisForm'
import { Expansible } from 'components/Expansible'
import { REVIEW_TYPES } from 'utils/constants/reviewTypes'
import Colors from 'utils/Colors'
import { REVIEW_STATUS, REVIEW_RESULT } from 'utils/constants/kypStatuses'
import { useSelector } from 'react-redux'
import jwtDecode from 'jwt-decode'

import { Alert } from '@mui/material'
import BuildScoreRelated from '../BuildScoreRelated'
import DisplayJustificative from './DisplayJustificative'

import styles from './styles'
import BuildSocialMediaInfo from './BuildSocialMediaInfo'
import BuildComplianceList from './BuildComplianceList'
import BuildPEPReviewInfo from './BuildPEPReviewInfo'
import BuildNegativeMediaReviewInfo from './BuildNegativeMediaReviewInfo'
import BuildRestrictionsReviewInfo from './BuildRestrictionsReviewInfo'
import BuildFamilyRelationsReviewInfo from './BuildFamilyRelationReviewInfo'
import BuildCompaniesReviewInfo from './BuildCompaniesReviewInfo'
import BuildFinancialPendingsInfo from './BuildFinancialPendingsInfo'
import BuildExternalActivityInfo from './BuildExternalActivityInfo'
import BuildAttorneyActivitiesInfo from './BuildAttoneyActivitiesInfo'
import BuildProcessesReviewInfo from './BuildProcessesReviewInfo'
import BuildAddressOcrReviewInfo from './BuildAddressOcrReviewInfo'
import BuildRepresentationActivityReviewInfo from './BuildRepresentationActivityReviewInfo'

const BuildListItem = (props) => {
  const { issue, onSubmitReview } = props
  const classes = styles()

  const token = useSelector((state) => state.auth.access_token)
  const role = jwtDecode(token)?.extras?.role

  const [review, setReview] = useState(issue)

  const updateReview = (newValue) => {
    setReview(newValue)
    onSubmitReview(newValue.result === REVIEW_RESULT.REPROVED)
  }

const buildLabel = (result, status, color) => {
  const renderContent = () => {
    switch (true) {
      case status === 'SUSPENDED':
        return (
          <React.Fragment>
            <Stop fontSize="small" />
            <span>Suspenso</span>
          </React.Fragment>
        )

      case result === REVIEW_RESULT.APPROVED:
        return (
          <React.Fragment>
            <ThumbUp fontSize="small" />
            <span>Aprovado</span>
          </React.Fragment>
        )

      case result === REVIEW_RESULT.REPROVED:
        return (
          <React.Fragment>
            <ThumbDown fontSize="small" />
            <span>Reprovado</span>
          </React.Fragment>
        )

      default:
        return (
          <React.Fragment>
            <SearchOutlined fontSize="small" />
            <span>Pendente</span>
          </React.Fragment>
        )
    }
  }

  return (
    <div
      className={classes.iconLabel}
      style={{ backgroundColor: color, color: '#FFFFFF' }}
    >
      {renderContent()}
    </div>
  )
}

  const getTitle = (title, result, status) => {
    const colors = {
      APPROVED: Colors.green,
      REPROVED: Colors.red,
      null: Colors.loginLigthenPrimaryColor, // no decision made
    }
    const color = status === 'SUSPENDED' ? Colors.orange  : colors[result]
    return (
      <div className={classes.titleContainer} style={{ color: colors[result] }}>
        <span>{title}</span>
        {buildLabel(result, status, color)}
      </div>
    )
  }

  return (
    <Expansible
      open={false}
      title={getTitle(
        review.review_type === 'negative_media'
          ? 'Mídia negativa'  
          : review.reason,
        review.result,
        review.status,
      )}
    >
      <div className={classes.issueContainer}>
        {review.review_type === REVIEW_TYPES.COMPANY_DATA && (
          <BuildCompaniesReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.PROCESS_DATA && (
          <BuildProcessesReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.SCORE_BOARD && (
          <BuildScoreRelated
            bgcScoreBoard={review.bgc_score_board}
            ddScoreBoard={review.dd_score_board}
          />
        )}
        {review.review_type === REVIEW_TYPES.FAMILY_RELATION_DATA && (
          <BuildFamilyRelationsReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.FINANCIAL_PENDINGS_DATA && (
          <BuildFinancialPendingsInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.SOCIAL_NETWORKS && (
          <BuildSocialMediaInfo socialNetworks={review.social_networks} />
        )}
        {review.review_type === REVIEW_TYPES.COMPLIANCE_LIST && (
          <BuildComplianceList listType={review.compliance_list} />
        )}
        {review.review_type === REVIEW_TYPES.PEP && (
          <BuildPEPReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.NEGATIVE_MEDIA && (
          <BuildNegativeMediaReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.RESTRICTIVE_LIST && (
          <BuildRestrictionsReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.REPRESENTATION_ACTIVITY && (
          <BuildRepresentationActivityReviewInfo reviewData={review} />
        )}
        {review.review_type === REVIEW_TYPES.EXTERNAL_ACTIVITIES && (
          <BuildExternalActivityInfo externalActivities={review.activities} />
        )}
        {review.review_type === REVIEW_TYPES.ATTORNEY_ACTIVITIES && (
          <BuildAttorneyActivitiesInfo activities={review.activities} />
        )}
        {review.review_type === REVIEW_TYPES.ADDRESS_OCR_DATA && (
          <BuildAddressOcrReviewInfo reviewData={review} />
        )}
        {review.status === REVIEW_STATUS.AWAITING_DECISION && review.reviewable_areas.includes(role) && (
          <ManualAnalysisForm
            reviewData={review}
            updateReview={updateReview}
          />
        )}
        {review.status === REVIEW_STATUS.SUSPENDED && review.reviewable_areas.includes(role) && (
           <div className={classes.root}>
            <Alert severity='warning'  >
              Análise manual suspensa. Nada a fazer porque o assessor já foi reprovado em outra análise.
            </Alert>
           </div>
        )}
        {review?.decisions?.length > 0 &&
          review.decisions.map((decision, index) => (
            <DisplayJustificative
              key={decision.uuid}
              status={decision?.area_decision}
              reviewerComment={decision?.reviewer_comment}
              reviewer={decision?.reviewer?.email}
              decisionNumber={review?.decisions?.length > 1 ? index : null}
            />
          ))}
      </div>
    </Expansible>
  )
}

export default BuildListItem
